import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="sand" eyebrow="Antes de decidir" title="Preguntas frecuentes" data-id="element-36" data-mp="1gcpfsz39k8rr">
      <ul className="mx-auto max-w-narrow space-y-3" data-id="element-37" data-mp="1gal3bsrau1fv">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <li key={faq.question} className="overflow-hidden rounded-2xl bg-white shadow-soft ring-1 ring-gray-200" data-id="element-38" data-mp="292ehzfrpmeuy" data-mpi={index}>
              <h3 data-id="element-39" data-mp="1z372on1f0a57">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 ease-calm hover:bg-canvas focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-forest-200 md:px-7" data-id="element-40" data-mp="1z3oxdf8figb0">
                  <span className="font-display text-lg font-extrabold tracking-tight text-ink" data-id="element-41" data-mp="ufzh9w2sxl15">
                    {faq.question}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-forest-600 transition-transform duration-200 ease-calm ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-42" data-mp="kiuupv51nnjt" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-43" data-mp="3sz6hlzfr4tmi">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-44" data-mp="1sd53zfid82o">
                    <p className="px-5 pb-6 text-lg leading-relaxed text-gray-500 md:px-7" data-id="element-45" data-mp="1uhw72rfd0aky">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}